import type { Thread, UserId } from "../types/collaborateThread";

export function normalizeUserId(id: string | undefined | null): string {
  return (id ?? "").trim().toLowerCase();
}

export function isSameUserId(a: string | undefined | null, b: string | undefined | null): boolean {
  const left = normalizeUserId(a);
  const right = normalizeUserId(b);
  return Boolean(left && right && left === right);
}

/** Thread participates in sign-off workflow (API may only send assignee + status). */
export function threadNeedsSignoff(thread: Thread): boolean {
  return thread.requireApproval === true || Boolean(thread.assignee);
}

/** True when the logged-in user is the pending assignee and may approve/reject. */
export function canCurrentUserApproveThread(thread: Thread, currentUserId: UserId): boolean {
  if (thread.status !== "pending" || !thread.assignee?.id) {
    return false;
  }
  return isSameUserId(thread.assignee.id, currentUserId);
}
